import { FuturePayment as CanadaFuturePaymentPb } from "@repo/protobuf/gen/kikoff_canada/protobuf/types/payments/future_payment_pb";
import { PaymentSchedule as UsaPaymentSchedulePb } from "@repo/protobuf/gen/web/public/credit_line_pb";
import Protobuf from "@repo/protobuf/utils";

type FuturePayment = {
  amountCents: number;
  dueAt: Date;
  scheduledAt?: Date;
};

namespace FuturePayment {}

export default FuturePayment;

export namespace FuturePaymentUsa {
  export const normalize = ({
    amountCents,
    dueDate,
    autopayableDate,
  }: UsaPaymentSchedulePb.Payment): FuturePayment => ({
    amountCents,
    dueAt: Protobuf.Timestamp.toDate(dueDate!),
    scheduledAt: Protobuf.Timestamp.toDate(autopayableDate),
  });
}

export namespace FuturePaymentCanada {
  export const normalize = ({
    amountCents,
    dueAt,
    scheduledAt,
  }: CanadaFuturePaymentPb): FuturePayment => ({
    amountCents,
    dueAt: Protobuf.Timestamp.toDate(dueAt!),
    scheduledAt: Protobuf.Timestamp.toDate(scheduledAt),
  });
}
